module.exports = __webpack_public_path__ + "static/media/blank_jacket.5affb462.gif";